import { z } from "zod";
import { CommunityFeature } from "../enum.js";

const SLUG_REGEX = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

export const updateCommunitySchema = z
	.object({
		name: z.string().min(3, { message: "Community name must be at least 3 characters" }).max(50),
		slug: z
			.string()
			.min(3, { message: "Slug must be at least 3 characters" })
			.max(30, { message: "Slug must be at most 30 characters" })
			.regex(SLUG_REGEX, { message: "Slug can only contain lowercase letters, numbers, and hyphens" }),
		description: z.string().max(500).optional(),
		image: z.url().nullable().optional(),
		cover_image: z.url().nullable().optional(),
		variant: z.enum(["default", "coral", "green", "sky"]),
		features: z.array(
			z.object({
				feature: z.enum(CommunityFeature),
				enabled: z.boolean(),
			}),
		),
	})
	.strict();

export type UpdateCommunityPayload = z.infer<typeof updateCommunitySchema>;
